import React from 'react';

interface Props {
  children: React.ReactNode;
}

export function DialogFooter({
  children,
}: Props) {
  return (
    <div className="dialog-footer">
      {children}
    </div>
  );
}